<template>
<div id="container" class="container impressum">
  <top-menu />
  <top-logo />
  <stoppuhr />
  <lautsprecher />
  <copyright />
  <div class="fullscreen_background">
    <img src="/static/assets/veranstaltungen/Hintergrund_2860.jpg" />
  </div>
  <div class="content">
    <div class="inner">
      <div class="ueberschrift">Impressum</div>
      <vuescrollbar class="content_text">
        <p>Verantwortlich für den Inhalt<br />H. Hugendubel GmbH & Co. KG<br />
Hilblestraße 54<br />
80636 München<br />
</p>
<p>Tel.: 089 - 30 75 75 75<br />
Fax: 089 - 30 75 75 30</p>
<p>Montag bis Samstag 9:00 - 20:00 Uhr<br />
service@hugendubel.de<br />
Registergericht München, HRA46568, HRB43385<br />
Umsatzsteuer-Ident-Nr.: DE 130499587</p>
<p>Hugendubel.com enthält Links zu anderen Websites. H. Hugendubel GmbH & Co. KG ist nicht
verantwortlich für die Inhalte dieser Websites. Sie unterliegen der Haftung der jeweiligen Anbieter.</p>
<p><strong>Geschäftsführung</strong><br />
Nina Hugendubel<br />
Dr. Maximilian Hugendubel <br />
Dr. Stephan Höllermann<br />
Oliver Mader<br />
Thomas Nitz</p>
<p><strong>Copyright</strong><br />
H. Hugendubel GmbH & Co. KG. Alle Rechte vorbehalten. Insbesondere dürfen Nachdruck, Aufnahme
in Online-Dienste und Internet und Vervielfältigung auf Datenträger wie CD-ROM, DVD-ROM etc.
nur nach vorheriger schriftlicher Zustimmung des Unternehmens erfolgen. Bildmotive dürfen nur für redaktionelle
Zwecke genutzt werden. Die Verwendung ist honorarfrei bei Quellenangabe. H. Hugendubel GmbH & Co.KG
übernimmt keine Haftung oder Garantie für die Aktualität, Richtigkeit und Vollständigkeit der auf dieser
Internetseite publizierten Informationen.</p>
      </vuescrollbar>
      </div>
    </div>
</div>
</template>

<script>
/* eslint-disable */
import Topmenu from '@/components/Topmenu.vue'
import Toplogo from '@/components/Toplogo.vue'
import Stoppuhr from '@/components/Stoppuhr.vue'
import Lautsprecher from '@/components/Lautsprecher.vue'
import Copyright from '@/components/Copyright.vue'
import VueScrollBar from 'vue-perfect-scrollbar'

window.$ = window.jQuery = require('jquery')

export default {
  name: 'impressum',
  data () {
    return {
      who: 'impressum'
    }
  },
  components: {
    'top-menu': Topmenu,
    'top-logo': Toplogo,
    'stoppuhr': Stoppuhr,
    'lautsprecher': Lautsprecher,
    'copyright': Copyright,
    'vuescrollbar': VueScrollBar
  },
  mounted () {
    this.$ga.page(this.$router)
  }
}
</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
}

/* Z-Index - Level */

.z1 {
  z-index: 10;
}

.z2 {
  z-index: 20;
}

.z3 {
  z-index: 30;
}

.z4 {
  z-index: 40;
}

.z5 {
  z-index: 50;
}

.z6 {
  z-index: 60;
}

.z7 {
  z-index: 70;
}

.z8 {
  z-index: 80;
}

.z9 {
  z-index: 90;
}

.z10 {
  z-index: 100;
}

.z11 {
  z-index: 110;
}

.z12 {
  z-index: 120;
}

.z13 {
  z-index: 130;
}

.z14 {
  z-index: 140;
}

.z15 {
  z-index: 150;
}

.z16 {
  z-index: 160;
}

.z17 {
  z-index: 170;
}

.z18 {
  z-index: 180;
}

.z19 {
  z-index: 190;
}

.z20 {
  z-index: 200;
}

.z21 {
  z-index: 210;
}

.z22 {
  z-index: 220;
}

.z23 {
  z-index: 230;
}

.z24 {
  z-index: 240;
}

.z25 {
  z-index: 250;
}

.z26 {
  z-index: 260;
}

.z27 {
  z-index: 270;
}

.z28 {
  z-index: 280;
}

.z29 {
  z-index: 290;
}

.z30 {
  z-index: 300;
}

.z31 {
  z-index: 310;
}

.z32 {
  z-index: 320;
}

.z33 {
  z-index: 330;
}

.z34 {
  z-index: 340;
}

.z35 {
  z-index: 350;
}

.z36 {
  z-index: 360;
}

.z37 {
  z-index: 370;
}

.z38 {
  z-index: 380;
}

.z39 {
  z-index: 390;
}

.z40 {
  z-index: 400;
}

.z41 {
  z-index: 410;
}

.z42 {
  z-index: 420;
}

.z43 {
  z-index: 430;
}

.z44 {
  z-index: 440;
}

.z45 {
  z-index: 450;
}

.z46 {
  z-index: 460;
}

.z47 {
  z-index: 470;
}

.z48 {
  z-index: 480;
}

.z49 {
  z-index: 490;
}

.z50 {
  z-index: 500;
}

.impressum .himmel {
  position: absolute;
  top: 0px;
  left: 0;
  width: 100%;
  height: auto;
}

.impressum .content {
position: absolute;
    top: 318px;
    left: 330px;
    width: 80%;
    height: 500px;
    font-size: 16pt;
    font-family: 'Open Sans';
    font-weight: 400;
}

.impressum .content .inner {
  position: relative;
}

.impressum .content .inner .ueberschrift {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  color: white;
  font-family: FrozenMemory;
  font-size: 36px;
}

.impressum .content .inner .content_text {
  position: absolute;
  top: 50px;
  left: 0;
  width: 1200px;
  height: 530px;
  /*overflow-y: scroll;*/
  padding-right: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/Impressum.vue